<template>
  <div class="app-container">

    <el-button type="primary" size="small" @click="goBack()">返回</el-button>
    <div style="padding-top: 20px"></div>
    <el-card>
      <el-form
          :model="slideImageInfo"
          ref="productSlideImageForm"
          v-loading="uploadLoading"
      >
        <el-form-item
            label="图片标题"
            prop="title"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="slideImageInfo.title"/>
        </el-form-item>
        <el-form-item label="选择图片">
          <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="change2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(slideImageInfo.faceUrl)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="90px" label="是否启用">
          <el-switch active-text="启用" inactive-text="未启用" :active-value="1" :inactive-value="0"
                     v-model="slideImageInfo.isEnabled"></el-switch>
        </el-form-item>
        <el-form-item
            label="类型"
            prop="type"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-select v-model="slideImageInfo.type" style="width: 100%">
            <el-option label="产品" :value="0"/>
            <el-option label="产品视频" :value="1"/>
            <el-option label="链接" :value="2"/>
          </el-select>
        </el-form-item>
        <el-form-item
            label="绑定ID"
            prop="bindId"
            v-if="slideImageInfo.type === 0 || slideImageInfo.type === 1 "
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input-number v-model="slideImageInfo.bindId"></el-input-number>
          <div class="el-upload__tip" style="color: #aaa">
            类型为产品时：绑定ID为产品的MachineSeriesID
          </div>
          <div class="el-upload__tip" style="color: #aaa">
            类型为产品视频时：绑定ID为视频videoID
          </div>
        </el-form-item>
        <el-form-item
            v-else
            label="链接地址"
            prop="linkUrl"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="slideImageInfo.linkUrl"></el-input>
        </el-form-item>
        <el-form-item
            v-if="userDataType.length > 0"
            label="所属领域"
            prop="userDataType"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-select v-model="slideImageInfo.userDataType" style="width: 100%">
            <el-option v-for="item in userDataType" :value="item.value" :key="item.value"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <el-button type="primary" size="small" @click="updateSlideImage()">保存</el-button>
    </el-card>

  </div>

</template>

<script>
import {isVaild} from "@/utils/validate";
import {
  addProductSliderImage,
  getProductSliderImageOne,
  updateProductSliderImage
} from "@/api/CarouselManagement/CarouselManagement";
import {handleRes} from "@/utils/handleRes";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {deepClone} from "@/utils";

export default {
  name: "ProductSliderImageDetail",
  created() {
    let queryID = this.$route.query.productSlideImageId
    if (isVaild(queryID)) {
      this.productSlideImageId = queryID;
    }
    this.getProductSliderImageOne();
  },
  data() {
    return {
      productSlideImageId: 0,
      userDataType: [],
      slideImageInfo: {},
      uploadCoverFile: null,
      uploadCoverFileURL: "",
      uploadLoading: false
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getProductSliderImageOne() {
      getProductSliderImageOne({
        productSlideImageId: this.productSlideImageId
      }).then(res => {
        handleRes(res, () => {
          this.slideImageInfo = res.data
        })
      })
    },
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    updateSlideImage(){
      this.$refs["productSlideImageForm"].validate(async (valid) => {
        if (valid) {
          this.uploadLoading = true
          let savepathParamsRes = await getOSSUploadInfo({
            DataType: "32",
            ID: "0",
          });
          if (!isVaild(savepathParamsRes)) {
            this.uploadLoading = false
            return;
          }
          let savePathParams = savepathParamsRes.resultData

          //上传封面
          if (isVaild(this.uploadCoverFile)) {
            // printObj(this.uploadCoverFile.raw)
            let timestamp = new Date().valueOf();

            let uploadRes;
            let fileName;
            if (isVaild(this.uploadCoverFile)) {
              fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
              // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
              uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
                type: this.uploadCoverFile.raw.type
              }), fileName)
            }
            if (uploadRes.status === 0) {
              this.slideImageInfo.faceUrl = "/" + fileName
              // console.log(this.form.liveCover)
            } else {
              this.$message({
                type: "error",
                message: "上传失败"
              })
            }
            this.$refs.uploadCoverRef.clearFiles();
          }

          const params = deepClone(this.slideImageInfo);
          updateProductSliderImage(params).then((res) => {
            handleRes(res, () => {
              this.getProductSliderImageOne()
            })
            this.uploadLoading = false
          });
        } else {
          this.$message({
            type: "error",
            message: "请完善数据",
          });
        }
      });
    }
  }
}
</script>

<style scoped>

</style>